import { lazy } from 'react'

export const SentryReactTestRoute = lazy(() =>
  import('../pages/SentryReactTestPage').then((module) => ({
    default: module.SentryReactTestPage,
  })),
)
